module.exports = () => {
	return new Promise((resolve) => {
		return resolve((screen.availWidth || 0) + 'x' + (screen.availHeight || 0));
	});
};
